import { useEffect, useState } from 'react';
import { getTrackingQueryParams } from '@pkgs/components/utils/stringUtils';

export const useQueryParams = () => {
  const [trackingQueryParams, setTrackingQueryParams] = useState<Record<string, string> | undefined>();

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const queryParams = getTrackingQueryParams(currentUrl);
    setTrackingQueryParams(queryParams);
  }, []);

  return trackingQueryParams;
};
